module.exports = __webpack_public_path__ + "static/media/tobcle-logo.0e4a6394.jpg";